<template>
  <div
    class="lv-qrcode"
    :class="{'mobile-border-top': mobileBorderTop}"
  >
    <WsText001
      v-if="title"
      bold
      h3
    >
      {{ $t(title) }}
    </WsText001>
    <qrcode-vue
      :render-as="'svg'"
      :value="url"
      :size="size"
      :margin="margin"
      :background="background"
      :foreground="foreground"
      class="qrcode"
    />
    <WsButton001
      v-if="btnText"
      widthStretch
      leading-icon="icon-md-qr_code"
      class="mt-15"
      @click="$_onPrint()"
    >
      {{ $t(btnText) }}
    </WsButton001>
    <StateInputButton
      v-if="isShowUrl"
      v-model="url"
      disabled
      :placeholder="$t('輸入')"
      :title="$t('網址 URL')"
      trailingIcon="icon-copy"
      class="mt-20"
      @click="$_onCopy()"
    />
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';

export default {
  components: {
    QrcodeVue,
  },
  props: {
    title: {
      type: String,
    },
    url: {
      type: String,
    },
    size: {
      type: Number,
    },
    margin: {
      type: Number,
    },
    background: {
      type: String,
    },
    foreground: {
      type: String,
    },
    btnText: {
      type: String,
    },
    isShowUrl: {
      type: Boolean,
      default: true,
    },
    mobileBorderTop: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    $_onPrint() {
      this.$emit('print');
    },
    async $_onCopy() {
      try {
        await navigator.clipboard.writeText(this.url);
        alert(this.$t('已複製連結'));
      } catch (error) {
        console.error(this.$t('複製失敗：'), error);
      }
    }
  }
}
</script>